export class UpdateTransactionSdaPinRequest {
  public sdaAmount: number;
  public pinAllocations: TransactionPinAllocation[] = [];
}

export class TransactionPinAllocation {
  public userFiaPinId: number;
  public amountToAllocate: number;
}
